import { ConfigProvider, theme } from "antd"
import { useTheme } from "../../context/Theme"

type Props = {
  children: React.ReactNode
}

export const ThemeWrapper: React.FC<Props> = ({ children }) => {
  const { isDarkMode } = useTheme() // Get theme state from context

  return (
    <ConfigProvider
      theme={{
        algorithm: isDarkMode ? theme.darkAlgorithm : theme.defaultAlgorithm,
      }}
    >
      {children}
    </ConfigProvider>
  )
}
